import { render, staticRenderFns } from "./LwfToggle.vue?vue&type=template&id=6071d84e&scoped=true&"
import script from "./LwfToggle.vue?vue&type=script&lang=js&"
export * from "./LwfToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071d84e",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QToggle});
